// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import IconModalClose from "@stoneage/XDL/Icons/IconModalClose";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            drawerTitle: css`
                background: transparent;
                min-height: 45px;
            `,
            drawerContainer: css`
                > div {
                    transition: 300ms ease-in-out;
                    background: ${getColor("common.white")};
                }
            `,
            titleButton: css`
                padding: 0;
                box-shadow: none !important;
                border: 0 !important;
                background: transparent !important;
                color: transparent;
                span:nth-child(3) {
                    display: none;
                }
                ${IconWrapper} {
                    color: ${color("primary.main")};
                }
                &:hover {
                    ${IconWrapper} {
                        color: ${color("primary")};
                    }
                }
            `,
            headlineTypography: css`
                margin: 7px 0 10px 0;
            `,
        },
        closeButtonIconProps: {
            src: IconModalClose,
            color: "primary.main",
            size: 24,
        },
        closeButtonProps: {
            shape: "pill",
            buttonType: "solid",
            size: 36,
            color: "transparent",
        },
    },
} as xBaseTheme["drawer"];
